/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1TransportColorModel } from '../../entities/v1/TransportColorModel'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1TransportColorModelSchema = z.object({
  color: z.string(),
  color_id: z.string(),
  name: z.string(),
}) as unknown as ToZod<V1TransportColorModel>